export default function StringToNumberDirective() {
  return {
    require: 'ngModel',
    link(__scope, __element, __attrs, ngModel) {
      ngModel.$parsers.push(value => `${value}`);
      ngModel.$formatters.push(value => parseFloat(value));
    }
  };
}
